<template>
  <div>
    <div class="row my-3">
      <div class="col-6">
        <h4>Krediidilimiit ületatud</h4>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-primary" @click="refresh" :disabled="working">
          <i class="mdi" :class="{'mdi-refresh': !working, 'mdi-loading mdi-spin': working}"></i> Uuenda
        </button>
      </div>
    </div>

    <i v-if="!clients" class="mdi mdi-loading mdi-spin mr-1 display-4"></i>

    <template v-else>
      <div v-if="!clients.length" class="alert alert-info">Ei leitud</div>
      <div v-else class="row">
        <div class="col-md-12 col-xl-12">
          <div class="card">
            <div class="card-body">
              <table class="table table-centered table-sm table-hover table-expandable table-sticky">
                <thead>
                <tr>
                  <th>Klient</th>
                  <th class="text-right">Määratud krediidilimiit</th>
                  <th class="text-right">Maksmata arvete summa</th>
                  <th class="text-right">Ületatud limiit</th>
                  <th class="text-right">Völg</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(client) in clients">
                  <tr>
                    <td><a @click="clientInvoices(client.clientId, client.clientName)">{{ client.clientName }}</a></td>
                    <td class="text-right">{{ client.creditLimit | amountWithCurrency }}</td>
                    <td class="text-right">{{ client.unpaidTotal | amountWithCurrency }}</td>
                    <td class="text-right">{{ client.overLimitAmount | amountWithCurrency }}</td>
                    <td class="text-right">{{ client.overdueAmount | amountWithCurrency }}</td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import gateway from '@/services/gateway'

export default {
  data() {
    return {
      clients: null,
      working: false
    }
  },
  methods: {
    clientInvoices(id, name) {
      this.$store.commit('client', {id: id, name: name})
      this.$router.push('/invoices')
      this.$store.commit('invoiceFilter', {
        type: 'normal',
        status: 'confirmed',
        clientId: id,
        numberPrefix: null,
        query: null
      })
    },
    refresh() {
      this.loadData(true)
    },
    loadData(refresh) {
      this.working = true
      gateway.get('/creditlimit-exceeded?refresh=' + refresh).then(r => this.clients = r.data).finally(() => this.working = false)
    }
  },
  created() {
    this.loadData(false)
  }
}
</script>
